module.exports = __webpack_public_path__ + "img/selected0-min.cd7b792f.png";